/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs */



/**
* | output |
* | --- |
* | "Insert surround single music notes to all selected events" |
*
* @param {Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_desc_insert_surround_music_note = /** @type {((inputs?: Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Desc_Insert_Surround_Music_NoteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inserer des notes de musique entourees pour tous les evenements selectionnes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Füge allen ausgewählten Ereignissen einzelne Surround-Musiknoten hinzu.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci singole note musicali surround a tutti gli eventi selezionati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вставить отдельные музыкальные ноты в объемном звучании ко всем выбранным событиям")
	if (locale === "es") return /** @type {LocalizedString} */ ("Insertar notas musicales envolventes individuales en todos los eventos seleccionados")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("为所有选定事件插入环绕单音符音乐")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択したすべてのイベントにサラウンド単一音符を挿入します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("सभी चयनित इवेंट्स में सराउंड सिंगल म्यूज़िक नोट्स डालें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Inserir notas musicais individuais em surround em todos os eventos selecionados")
	return /** @type {LocalizedString} */ ("Insert surround single music notes to all selected events")
});